import { useContext } from "react";
import { BreakdownContext } from "../providers";

/**
 * Hook that returns the breakdown context value
 * 
 * @returns The breakdown context
 */
const useBreakdown = () => {
  const breakdownContext = useContext(BreakdownContext);

  if (!breakdownContext) {
    throw new Error("useBreakdown must be used within an BreakdownProvider");
  }
  return breakdownContext;
};

export default useBreakdown;
